module.exports = __webpack_public_path__ + "img/exchange-arrow.c32408c8.svg";